module.exports = __webpack_public_path__ + "img/icon_upload@2x.2ddb1a52.png";